/** すべての板API requestが明示するAPI契約の既定version。 */
export const API_VERSION = "2026-08-29";
export const API_VERSION_HEADER = "X-Api-Version";
